import {SpellCheckPackage} from 'substance'

import {IdfImporter} from './services/IdfImporter'
import {IdfExporter} from './services/IdfExporter'
import {IdfDocument} from './services/IdfDocument'
import {DWSuggestionTool} from './tools/suggestion-tool/DWSuggestionTool'

import {BodyPackage} from './components/body/BodyPackage'
import {TextPackage} from './components/text/TextPackage'
import {ParagraphPackage} from './components/paragraph/ParagraphPackage'
import {StrongPackage} from './components/strong/StrongPackage'
import {EmphasisPackage} from './components/emphasis/EmphasisPackage'
import {UnsupportedPackage} from './components/unsupported/UnsupportedPackage'

import './scss/idf.scss'

const IdfPackage = {
    name: 'idf',
    configure(configurator) {
        configurator.addImporter('idf', IdfImporter)
        configurator.addExporter('idf', IdfExporter)

        configurator.defineSchema({
            name: 'idf',
            ArticleClass: IdfDocument,
            defaultTextType: 'paragraph',
            version: '2.20'
        })

        // TODO: Spellcheckern should be moved into the Writer so below hack is not necessary
        configurator.import(SpellCheckPackage)

        // HACK: Remove already registered substance tool, we don't use it, and it's in the wrong toolgroup
        configurator.getToolGroups().get('context-menu-primary').tools.delete('correction')

        // Add our own correction tool
        configurator.addContextMenuTool('correction', DWSuggestionTool, { toolGroup: 'context-menu-spelling' })

        configurator.import(BodyPackage)
        configurator.import(TextPackage)
        configurator.import(ParagraphPackage)

        // core annotation tools
        configurator.import(StrongPackage, {toolGroup: 'overlay'})
        configurator.import(EmphasisPackage, {toolGroup: 'overlay'})

        // Unsopported must be imported after all other packages
        configurator.importAfter(UnsupportedPackage)
    }
}

export {IdfPackage}
